import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { RenderIfModule } from '@shared/directives/render-if.module';
import { ProductBlockComponent } from './product-block.component';


import { ScrollModule } from 'app/shared/scroll/scroll.module';
// import { CardEditBarModule } from '@shared/components/card-edit-bar/card-edit-bar.module';

@NgModule({
    imports: [
    CommonModule,
    ScrollModule
    // CardEditBarModule,
    // RenderIfModule
    ,
    ProductBlockComponent
],
    exports: [
        ProductBlockComponent
    ]
})
export class ProductBlockModule { }
